import { useEffect, useRef, useState } from "react";

export default function Footer() {
  const footerRef = useRef<HTMLElement>(null);
  const [privacyOpen, setPrivacyOpen] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const children = entry.target.querySelectorAll(".footer-animate");
            children.forEach((child, i) => {
              setTimeout(() => child.classList.add("visible"), i * 60);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <footer
        ref={footerRef}
        id="footer"
        className="relative bg-[#f5f5f7]"
      >
        <div className="w-full px-6 md:px-10 lg:px-16 py-16 md:py-20">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10 mb-14">
              <div>
                <svg width="130" height="26" viewBox="0 0 644 127" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-5">
                  <mask id="mask0_4701_39325" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="127" height="127">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H126.48V126.48H0V0Z" fill="white"/>
                  </mask>
                  <g mask="url(#mask0_4701_39325)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M63.0468 -0.000149568C79.2959 -0.0502642 93.9043 7.77955 106.303 20.1769C118.651 32.5242 126.48 47.0539 126.48 63.2373V63.0452C126.53 79.2943 118.701 93.9027 106.303 106.301C93.9544 118.65 79.4271 126.478 63.2425 126.478H63.4334C47.1855 126.529 32.5759 118.699 20.1773 106.301C7.83123 93.9528 0.000227925 79.4244 0.000227925 63.2409V63.433C-0.0486935 47.184 7.78112 32.5744 20.1773 20.1769C32.5258 7.82966 47.0543 -0.00134277 63.2377 -0.00134277L63.0468 -0.000149568Z" fill="#F96B25"/>
                  </g>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M80.9417 35.4999C69.3058 35.2512 64.2532 41.3452 63.0213 47.2676C61.1985 43.8662 58.7347 39.7981 55.1079 37.757C53.1474 36.6547 49.3594 35.7265 44.0861 35.2944C38.8619 34.8671 35.6788 32.5236 35.6788 32.5236C35.6788 32.5236 35.6321 39.4244 35.5013 45.5407C35.2526 57.1764 41.3456 62.2289 47.2692 63.4596C43.8678 65.2846 39.7996 67.7472 37.7585 71.3752C36.655 73.3333 35.7279 77.1224 35.2958 82.3967C34.8684 87.6197 32.5249 90.8016 32.5249 90.8016C32.5249 90.8016 39.4259 90.8494 45.5422 90.9802C57.1782 91.2301 62.2308 85.1361 63.4615 79.2137C65.2854 82.6151 67.7481 86.6832 71.3761 88.7231C73.3355 89.8254 77.1246 90.7525 82.399 91.1845C87.6221 91.6131 90.804 93.9566 90.804 93.9566C90.804 93.9566 90.8519 87.0557 90.9827 80.9395C91.2314 69.3037 85.1384 64.2524 79.2147 63.0194C82.6174 61.1967 86.6856 58.7329 88.7255 55.1061C89.8278 53.1456 90.755 49.3577 91.187 44.0846C91.6155 38.8605 93.9579 35.6774 93.9579 35.6774C93.9579 35.6774 87.0581 35.6307 80.9417 35.4999" fill="#293041"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M207.749 113.603V71.9416H173.27V113.603H151.774V11.2753H173.27V52.3529H207.749V11.2753H229.244V113.603H207.749Z" fill="#293041"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M287.374 115.067C263.193 115.067 247.817 101.472 247.817 73.9898V11.2753H269.313V74.1359C269.313 88.6078 276.33 95.6228 287.523 95.6228C298.718 95.6228 305.734 88.7539 305.734 74.5739V11.2753H327.08V73.5518C327.08 101.62 311.408 115.067 287.374 115.067" fill="#293041"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M401.541 45.6281C401.541 34.9586 394.823 30.426 384.674 30.426H368.553V61.2702H385.122C395.273 61.2702 401.541 55.8634 401.541 46.2141V45.6281ZM401.394 113.604L382.287 79.981H368.555V113.604H347.06V11.2756H386.018C408.857 11.2756 423.334 22.9712 423.334 45.1902C423.334 60.8324 415.275 70.6257 403.933 75.5984L426.022 113.604H401.394Z" fill="#293041"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M513.575 113.603V48.2603L488.945 90.5061H488.497L464.016 48.6964V113.603H443.119V11.2753H465.809L488.796 52.791L511.933 11.2753H534.772V113.603H513.575Z" fill="#293041"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M596.081 39.9273L584.588 73.2578H607.425L596.081 39.9273ZM621.759 114.19L613.998 91.9686H578.172L570.411 114.19H548.769L586.083 11.2756H606.684L644 114.19H621.759Z" fill="#293041"/>
                </svg>
                <p className="text-[#86868b] text-base leading-relaxed max-w-[260px]">
                  All-in-one HR & Recruitment platform for modern teams.
                </p>
              </div>
              <div className="flex items-center gap-3">
                <a
                  href="https://www.facebook.com/HurmaSystem"
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label="Facebook"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#1d1d1f]/[0.06] text-[#86868b] hover:bg-brand-orange/20 hover:text-brand-orange transition-all duration-200"
                >
                  <i className="ri-facebook-fill text-sm" />
                </a>
                <a
                  href="https://t.me/hurmainfo"
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label="Telegram"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#1d1d1f]/[0.06] text-[#86868b] hover:bg-brand-orange/20 hover:text-brand-orange transition-all duration-200"
                >
                  <i className="ri-telegram-fill text-sm" />
                </a>
                <a
                  href="https://www.youtube.com/c/HurmaSystem"
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label="YouTube"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#1d1d1f]/[0.06] text-[#86868b] hover:bg-brand-orange/20 hover:text-brand-orange transition-all duration-200"
                >
                  <i className="ri-youtube-fill text-sm" />
                </a>
                <a
                  href="https://www.instagram.com/hurma.system/"
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label="Instagram"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#1d1d1f]/[0.06] text-[#86868b] hover:bg-brand-orange/20 hover:text-brand-orange transition-all duration-200"
                >
                  <i className="ri-instagram-line text-sm" />
                </a>
              </div>
            </div>

            <div className="border-t border-[#d2d2d7] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex items-center gap-4">
                <p className="text-[#86868b] text-xs">
                  © 2026 HURMA. All rights reserved.
                </p>
                <button
                  onClick={() => setPrivacyOpen(true)}
                  className="text-[#86868b] text-xs underline underline-offset-2 hover:text-[#1d1d1f] transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  Політика конфіденційності
                </button>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400 inline-block" />
                <span className="text-[#86868b] text-xs">All systems operational</span>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {privacyOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
          onClick={() => setPrivacyOpen(false)}
        >
          <div
            className="relative bg-white rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto p-8 md:p-10 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setPrivacyOpen(false)}
              className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full bg-[#f5f5f7] text-[#86868b] hover:bg-[#e8e8ed] hover:text-[#1d1d1f] transition-all duration-200 cursor-pointer"
              aria-label="Закрити"
            >
              <i className="ri-close-line text-lg" />
            </button>

            <h2 className="text-xl md:text-2xl font-semibold text-[#1d1d1f] mb-6">
              Політика конфіденційності
            </h2>

            <div className="prose prose-sm text-[#86868b] leading-relaxed space-y-4">
              <p>
                Вебсторінка не здійснює безпосереднього збору персональних даних користувачів через форми зворотного зв'язку або іншим чином.
              </p>
              <p>
                Для аналізу відвідуваності та оцінки ефективності роботи цієї вебсторінки можуть використовуватися сервіси веб-аналітики (зокрема, але не виключно, Google Analytics), які обробляють технічну інформацію про використання вебсторінки, серед яких можуть бути дані про перегляди сторінок, тип пристрою, браузер, операційну систему та іншу інформацію, необхідну для формування статистичних звітів і покращення роботи ресурсу.
              </p>
              <p>
                Зазначені технічні дані використовуються агреговано без мети прямої ідентифікації конкретної фізичної особи.
              </p>
              <p>
                Вебсторінка може містити посилання, які переспрямовують Користувача на інші вебсайти. Обробка та збір персональних даних здійснюються відповідно до Політик конфіденційності, розміщених на відповідних вебсайтах.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}